import { Component, OnInit } from '@angular/core';
import {LoginResponse, UserRoleString} from "../../models/user";
import {Router} from "@angular/router";
import {StateService} from "../../services/state.service";
import {HttpHeaders} from "@angular/common/http";
import {catchError, throwError} from "rxjs";
import {HttpService} from "../../services/http.service";
import {UtilService} from "../../services/util.service";
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegisterComponent } from '../register/register.component';
@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent implements OnInit {

  constructor(private router: Router,
              public stateService : StateService,
              private httpService : HttpService,
              private util : UtilService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  isProd() : boolean {
    return window.location.host == "epds.gao.gov";

  }

  async onLogin(form: any) {
    let hashHex = await this.util.digestMessage(form.pwd.trim());
    const value = {
      password: window.btoa(hashHex + ":"),
      email: window.btoa(form.email),
    }
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {...headers};
    this.httpService.Post<LoginResponse>('/user/login', value, options).pipe(
      catchError(err => {
        // console.log('Handling error locally.', err);
        return throwError(err);
      })
    ).subscribe(response => {
      console.log(response);
      if (response.isLoginSuccess) {
        this.stateService.loginResponse = response;
        if (response.data) this.stateService.user = response.data;
        // this.util.init();
        let dto = response.dto;
        if(dto.account_status_id === 8 || dto.account_status_id === 7 || dto.account_status_id === 6){
          this.util.displayDialogMessage("Account Reset",
            "Your account has been reset. Please select Ok and you will be asked to update your password")
            .pipe()
            .subscribe(res => {
              if (res) {
                this.router.navigate(['/user/change-pwd']);
              }
            });
        } else if (dto.account_status_id === 5) {
          this.util.displayDialogMessage("Account Expired",
            "Your password has expired. Please select OK to reset your password")
            .pipe()
            .subscribe(resp => {
              if (resp) {
                this.router.navigate(['/user/change-pwd/expired']);
              }
            });
        } else if (dto.account_status_id === 1) {
          this.util.displayDialogMessage("New Account",
            "You are accessing EPDS for the first time. You need to update your password and security questions. Please select OK and you will be asked to update your password and security questions.")
            .pipe()
            .subscribe(resp => {
              if (resp) {
                this.router.navigate(['/user/change-pwd/new']);
              }
            });
        } else if (dto.account_status_id === 3) {
          this.util.displayDialogMessage("Account Locked",
            "Too many incorrect passwords, please use the 'I forgot my password' link.")
            .pipe()
            .subscribe(resp => {
              if (resp) {
                this.router.navigate(['/']);
              }
            });
        }
        else {
          // this.util.init();
          this.stateService.checkRedirect(this.util.getDashboardURL());
        }
      } else {
        this.util.displayDialogMessage("Login Failure", response.message);
      }
    });
    // if (this.stateService.isLoggedIn && this.stateService.user.user_id !== "") {
    //   this.router.navigate([this.util.getDashboardURL()] );
    // } else if (this.stateService.isLoggedIn) {
    //   this.router.navigate(['/register'] );
    // } else {
    //   // if (event.shiftKey && event.altKey && event.ctrlKey) {
    //   //   this.router.navigate(['/login'] );
    //   // } else {
    //     window.open('/ui/oauth2/authorization/custom', '_self');
    //   // }
    // }
  }

  userGuide() {

  }

  onRegister() {
    const dialogRef:MatDialogRef<RegisterComponent> = this.dialog.open(RegisterComponent, {
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  forgotPassword() {
    const dialogRef:MatDialogRef<ForgotPasswordComponent> = this.dialog.open(ForgotPasswordComponent, {
      data: {email: ''},
      width: '415px',
    });

    dialogRef.afterClosed().subscribe(result => {});
  }
}
